export default "__VITE_ASSET__BLv4ANws__"